import { Injectable } from '@angular/core';

const USER_COLOR_PALETTE = [
  '#E57373',
  '#64B5F6',
  '#81C784',
  '#FFB74D',
  '#BA68C8',
  '#4DB6AC',
  '#FF8A65',
  '#7986CB',
  '#A1887F',
  '#F06292',
  '#4DD0E1',
  '#FFD54F',
] as const;

@Injectable({ providedIn: 'root' })
export class UserColorService {
  getColorForUser(userId: string | undefined): string {
    if (!userId) {
      return '#90A4AE';
    }

    const index = Math.abs(this.hashString(userId)) % USER_COLOR_PALETTE.length;
    return USER_COLOR_PALETTE[index];
  }

  private hashString(value: string): number {
    let hash = 0;

    for (let i = 0; i < value.length; i++) {
      hash = (hash << 5) - hash + value.charCodeAt(i);
      hash |= 0;
    }

    return hash;
  }
}
